const ON_WEB = typeof document != 'undefined'; 
const LOCAL_FUNCTION_API = "http://localhost:5000/";
const WEB_FUNCTION_API = "https://us-central1-community-feed-94834.cloudfunctions.net/";
const BACKEND_API ="https://api.feed.community/";

export {ON_WEB, LOCAL_FUNCTION_API, WEB_FUNCTION_API, BACKEND_API};
